import { App } from 'antd';

import { BFC } from '@/shared/types';

import { AntdNotificationsProvider } from './AntdNotificationsProvider';

/**
 * NoticesProvider
 * - <App/> for App.useApp message
 * - notification.useNotification for notificationApi
 */
export const NoticesProvider: BFC = ({ children }) => {
  return (
    <App>
      <AntdNotificationsProvider>{children}</AntdNotificationsProvider>
    </App>
  );
};
